import { Fragment, useCallback, useContext, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { AngularContext } from 'react-app';
import { useAppDispatch } from 'redux/store';
import MentoringProgramContext from 'athena/components/mentoring-program/context';
import { clearLastMentorsSearchAndFilters } from 'redux/actions/mentoring-program-participant-driven';
import BrowseMentorsModal from './browse-mentors-modal';
import { config } from '@config/pendo.config.json';


type FindAMentorButtonProps = {
  label: string;
};

const FindAMentorButton = ({ label }: FindAMentorButtonProps) => {
  const dispatch = useAppDispatch();
  const { injectServices } = useContext(AngularContext);
  const [$state] = injectServices(['$state']);
  const { showBrowseMentors = false } = $state.params;
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { showFindMentorModal, setShowFindMentorModal } = mentoringProgram;

  const handleOpenFindMentorModal = () => {
    setShowFindMentorModal(true);
  };

  const handleCloseFindMentorModal = () => {
    dispatch(clearLastMentorsSearchAndFilters());
    setShowFindMentorModal(false);
  };

  const resetShowBrowseMentorsParam = useCallback(() => {
    const params = { showBrowseMentors: undefined };
    $state.go($state.current, params, { notify: false });
  }, [$state]);

  useEffect(() => {
    if (showBrowseMentors) {
      setShowFindMentorModal(true);
      resetShowBrowseMentorsParam();
    }
  }, [showBrowseMentors, setShowFindMentorModal, resetShowBrowseMentorsParam]);

  const dataQATag = config.pendo.athena.mentorshipProgram.participantHome.steps.findAMentor;

  return (
    <Fragment>
      <Button
        size='lg'
        onClick={handleOpenFindMentorModal}
        data-qa={dataQATag}
      >
        {label}
      </Button>
      {showFindMentorModal && (
        <BrowseMentorsModal
          onClose={handleCloseFindMentorModal}
        />
      )}
    </Fragment>
  );
};

export default FindAMentorButton;
